import { AnsweredResponseDto } from '../generated-types/answeredResponseDto';
import { GetQuestionResponse } from '../generated-types/getQuestionResponse';
import { AbstractAnswerWithDis } from '../types/QuestionAndAnswersWithDiscriminator';
import { AbstractApi } from './AbstractApi';

/**
 * An api to interact with the courses controller
 */
export default class QuestionsApi extends AbstractApi {
  /**
   * Get the next quiz question
   * @param moduleId The quiz module to get the next question for
   * @returns The next question for the logged in user
   */
  async GetNextQuestion(moduleId: string): Promise<GetQuestionResponse> {
    const response = await this.authFetch(
      this.BuildUrl(`quiz/${moduleId}/questions/next`),
      {
        method: 'GET',
      }
    );

    if (!response.ok) throw Error();

    return response.json() as unknown as GetQuestionResponse;
  }

  /**
   * Answer the given question
   * @param questionId The id of the question that's being answered
   * @param answer The user's answer to the question
   * @returns The answer response that can be processed in the frontend
   */
  async AnswerQuestion(
    questionId: string,
    answer: AbstractAnswerWithDis
  ): Promise<AnsweredResponseDto> {
    const response = await this.authFetch(
      this.BuildUrl(`quiz/questions/${questionId}`),
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(answer),
      }
    );

    if (!response.ok) throw Error();

    return response.json() as unknown as AnsweredResponseDto;
  }

  /**
   * Get the number of correctly answered questions for the specified module
   * @param moduleId The module id to get the answered questions for
   * @returns The number of correctly answered questions for the specified module
   */
  async AnsweredQuestionCount(moduleId: string): Promise<number> {
    const response = await this.authFetch(
      this.BuildUrl(`quiz/${moduleId}/questions/answered-count`),
      {
        method: 'GET',
      }
    );

    if (!response.ok) throw Error();

    return response.text() as unknown as number;
  }
}
